import React from "react";

const CloseSquare = () => {
  return (
    <svg
      width="10"
      height="9"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.67383 16.8721H14.3174C16.2158 16.8721 17.2002 15.8877 17.2002 14.0156V3.31934C17.2002 1.43848 16.2158 0.462891 14.3174 0.462891H3.67383C1.77539 0.462891 0.791016 1.43848 0.791016 3.31934V14.0156C0.791016 15.8965 1.77539 16.8721 3.67383 16.8721ZM6.13477 12.3809C5.66895 12.3809 5.30859 12.0117 5.30859 11.5371C5.30859 11.3262 5.39648 11.124 5.55469 10.9658L7.84863 8.66309L5.55469 6.36914C5.39648 6.21094 5.30859 6.00879 5.30859 5.78906C5.30859 5.32324 5.66895 4.97168 6.13477 4.97168C6.37207 4.97168 6.55664 5.05078 6.71484 5.20898L9.01758 7.50293L11.3379 5.2002C11.5049 5.0332 11.6895 4.9541 11.9268 4.9541C12.3838 4.9541 12.7441 5.31445 12.7441 5.78027C12.7441 6 12.6738 6.19336 12.5068 6.36035L10.2041 8.66309L12.498 10.957C12.6562 11.1152 12.7441 11.3174 12.7441 11.5371C12.7441 12.0117 12.375 12.3809 11.9092 12.3809C11.6719 12.3809 11.4609 12.293 11.3115 12.1348L9.01758 9.84082L6.74121 12.1348C6.57422 12.293 6.37207 12.3809 6.13477 12.3809Z"
        fill="#1C1C1E"
      />
    </svg>
  );
};

export default CloseSquare;
